// import VectorLayer  from "ol/layer/Vector";
// import VectorSource from "ol/source/Vector";
// import Feature      from "ol/Feature";
// import Point        from "ol/geom/Point";
// import LineString   from "ol/geom/LineString";
// import Select       from "ol/interaction/Select";
// import Modify       from "ol/interaction/Modify";
// import Snap         from "ol/interaction/Snap";
// import Draw         from "ol/interaction/Draw";
// import Style        from "ol/style/Style";
// import Stroke       from "ol/style/Stroke";
// import Fill         from "ol/style/Fill";
// import CircleStyle  from "ol/style/Circle";
// import Text         from "ol/style/Text";
// import WKB from "ol/format/WKB";
// import { click }    from "ol/events/condition";

// export const WP_TYPES = Object.freeze({
//   START: "start", STOP: "stop", THROUGH: "through", BREAK: "break", VIA: "via",
// });

// export const TYPE_COLORS = {
//   [WP_TYPES.START]:   "#2e7d32",
//   [WP_TYPES.STOP]:    "#c62828",
//   [WP_TYPES.THROUGH]: "#1565c0",
//   [WP_TYPES.BREAK]:   "#f57f17",
//   [WP_TYPES.VIA]:     "#6a1b9a",
// };

// // ── Styles ──────────────────────────────────────────────
// const wpStyle = (f) => {
//   const type  = f.get("wp_type")  ?? WP_TYPES.THROUGH;
//   const index = f.get("wp_index") ?? 0;
//   const color = TYPE_COLORS[type] ?? "#333";
//   return [
//     new Style({
//       image: new CircleStyle({
//         radius: 8,
//         fill:   new Fill({ color }),
//         stroke: new Stroke({ color: "#fff", width: 2 }),
//       }),
//     }),
//     new Style({
//       text: new Text({
//         text: String(index + 1),
//         font: "bold 10px sans-serif",
//         fill: new Fill({ color: "#fff" }),
//         offsetY: 0.5,
//       }),
//     }),
//   ];
// };

// const TEMP_STYLE = new Style({
//   stroke: new Stroke({ color: "#1565c0", width: 3, lineDash: [8, 4] }),
// });

// const ROUTE_STYLE = new Style({
//   stroke: new Stroke({ color: "#1565c0", width: 4 }),
// });

// // ── OSRM ────────────────────────────────────────────────
// async function osrmFetch(url, profile, waypoints) {
//   const coords = waypoints.map(w => `${w[0]},${w[1]}`).join(";");
//   const res    = await fetch(
//     `${url}/route/v1/${profile}/${coords}?overview=full&geometries=geojson`
//   );
//   const data   = await res.json();
//   if (data.code !== "Ok" || !data.routes?.length) return null;
//   return data.routes[0].geometry.coordinates;
// }

// // ── Distance helpers ─────────────────────────────────────
// function cumulativeDist(coords) {
//   const dist = [0];
//   for (let i = 1; i < coords.length; i++) {
//     const dx = coords[i][0] - coords[i-1][0];
//     const dy = coords[i][1] - coords[i-1][1];
//     dist.push(dist[i-1] + Math.sqrt(dx*dx + dy*dy));
//   }
//   return dist;
// }

// function findInsertIndex(dragCoord, lineCoords, guidePoints) {
//   if (!lineCoords.length || !guidePoints.length) return 1;
//   const cumDist = cumulativeDist(lineCoords);
//   let minDist = Infinity, dragDist = 0;
//   lineCoords.forEach((c, i) => {
//     const d = (c[0]-dragCoord[0])**2 + (c[1]-dragCoord[1])**2;
//     if (d < minDist) { minDist = d; dragDist = cumDist[i]; }
//   });
//   const gpDists = guidePoints.map(gp => {
//     let minD = Infinity, gpDist = 0;
//     lineCoords.forEach((c, i) => {
//       const d = (c[0]-gp[0])**2 + (c[1]-gp[1])**2;
//       if (d < minD) { minD = d; gpDist = cumDist[i]; }
//     });
//     return gpDist;
//   });
//   let idx = 1;
//   for (let i = 0; i < gpDists.length - 1; i++) {
//     if (gpDists[i] <= dragDist) idx = i + 1;
//   }
//   return idx;
// }

// // ─────────────────────────────────────────────────────────
// // ROUTE EDITOR CORE
// //
// // mode: "none" | "draw" | "select"   ← matches GeometryEditor pattern
// //
// // DRAW mode:
// //   Click to add waypoints → OSRM between each pair → temp preview line
// //   Backspace removes last waypoint (no undo stack during active draw)
// //   addFeature() commits preview as real feature + pushes to undoStack
// //
// // SELECT mode:
// //   Click existing route → loads guide_points as draggable markers
// //   Drag marker (modifyMarkers) → update guide_point → reroute
// //   Drag line vertex (modifyLine) → insert new guide_point → reroute
// //   Both drag operations push to undoStack
// //
// // UNDO/REDO:
// //   Covers: addFeature, deleteSelected, drag-modify
// //   Does NOT cover: active draw (use backspace instead)
// // ─────────────────────────────────────────────────────────
// export default class RouteEditorCore {
//   constructor(map, routeLayer, logger, opts = {}) {
//     this.map         = map;
//     this.routeLayer  = routeLayer;
//     this.routeSource = routeLayer.getSource();
//     this.logger      = logger;
//     this.osrmUrl     = opts.osrmUrl ?? "https://router.project-osrm.org";
//     this.profile     = opts.profile ?? "driving";

//     this.onStatusChange    = opts.onStatusChange    ?? null;
//     this.onWaypointsChange = opts.onWaypointsChange ?? null;
//     this.onFeatureAdded    = opts.onFeatureAdded    ?? null;
//     this.onCommit          = opts.onCommit          ?? null;

//     this.editing         = false;
//     this.loading         = false;
//     this.mode            = "none";   // "none" | "draw" | "select"

//     // Active draw waypoints — backspace pops from here, NOT from undoStack
//     this._guidePoints    = [];
//     this._activeFeature  = null;

//     // Undo/Redo — only for committed operations (addFeature, delete, drag)
//     this._undoStack      = [];
//     this._redoStack      = [];

//     // Backspace handler ref (removed on drawend / stopEdit)
//     this._onBackspace    = null;

//     // Overlay layer for waypoint markers
//     this._wpSource = new VectorSource();
//     this._wpLayer  = new VectorLayer({
//       source: this._wpSource,
//       zIndex: 200,
//       style:  wpStyle,
//     });
//     map.addLayer(this._wpLayer);

//     this._buildInteractions();

//     // Waypoint snap — created after interactions, added last = highest priority
//     this._wpSnap = new Snap({ source: this._wpSource, pixelTolerance: 15 });
//     this.map.addInteraction(this._wpSnap);
//   }

//   // ─────────────────────────────────────────────────────────
//   // INTERACTIONS
//   // ─────────────────────────────────────────────────────────
//   _buildInteractions() {
//     // Select existing route features (select mode)
//     this._selectRoute = new Select({
//       layers:    [this.routeLayer],
//       condition: click,
//       filter:    f => !f.get("_temp_line"),
//       style:     null,
//     });
//     this.map.addInteraction(this._selectRoute);

//     this._selectRoute.on("select", e => {
//       if (!this.editing || this.mode !== "select") return;
//       const f = e.selected[0];
//       if (f) this._loadFeature(f);
//       else   this._clearMarkers();
//     });

//     // Draw — click to add waypoints (draw mode)
//     this._draw = new Draw({ source: this._wpSource, type: "Point" });
//     this._draw.setActive(false);
//     this.map.addInteraction(this._draw);

//     // Backspace handler — attached when draw mode starts, removed on mode switch
//     this._onBackspace = null;

//     this._draw.on("drawend", e => {
//       // Remove auto-added point from wpSource — we manage manually
//       setTimeout(() => this._wpSource.removeFeature(e.feature), 0);
//       const lonLat = e.feature.getGeometry().getCoordinates();
//       this._addGuidePoint(lonLat);
//     });

//     // Modify markers — drag guide_point markers
//     this._modifyMarkers = new Modify({ source: this._wpSource });
//     this._modifyMarkers.setActive(false);
//     this.map.addInteraction(this._modifyMarkers);

//     this._preDragGuidePoints = null;
//     this._modifyMarkers.on("modifystart", () => {
//       this._preDragGuidePoints = this._guidePoints.map(ll => [...ll]);
//     });
//     this._modifyMarkers.on("modifyend", e => {
//       const f = e.features.getArray()[0];
//       if (!f) return;
//       const wpIdx  = f.get("wp_index");
//       const lonLat = f.getGeometry().getCoordinates();
//       if (wpIdx === undefined) return;
//       // Push undo BEFORE applying
//       this._pushUndo({ type: "drag", prev: this._preDragGuidePoints, featureId: this._activeFeature?.getId() ?? null });
//       this._guidePoints[wpIdx] = lonLat;
//       this._syncWpMarkers();
//       this._emitWaypoints();
//       this._rerouteAndUpdateFeature();
//     });

//     // Modify line — drag directly on route line vertex
//     this._modifyLine = new Modify({ features: this._selectRoute.getFeatures() });
//     this._modifyLine.setActive(false);
//     this.map.addInteraction(this._modifyLine);

//     this._preDragLineCoords = null;
//     this._modifyLine.on("modifystart", e => {
//       this._preDragGuidePoints = this._guidePoints.map(ll => [...ll]);
//       const f = e.features.getArray()[0];
//       this._preDragLineCoords = f
//         ? f.getGeometry().getCoordinates().map(c => [...c])
//         : null;
//     });
//     this._modifyLine.on("modifyend", e => {
//       if (!this._activeFeature) return;
//       const f           = e.features.getArray()[0];
//       const afterCoords = f?.getGeometry().getCoordinates() ?? [];
//       const beforeCoords= this._preDragLineCoords ?? [];

//       // Find vertex that moved most
//       let dragCoord = null, maxDist = 0;
//       afterCoords.forEach(ac => {
//         const nearestDist = beforeCoords.reduce((best, bc) => {
//           const d = (ac[0]-bc[0])**2 + (ac[1]-bc[1])**2;
//           return Math.min(best, d);
//         }, Infinity);
//         if (nearestDist > maxDist) { maxDist = nearestDist; dragCoord = ac; }
//       });

//       if (!dragCoord || maxDist < 1e-10) return;

//       this._pushUndo({ type: "drag", prev: this._preDragGuidePoints, featureId: this._activeFeature?.getId() ?? null });
//       const insertIdx = findInsertIndex(dragCoord, afterCoords, this._guidePoints);
//       this._guidePoints.splice(insertIdx, 0, dragCoord);
//       this._syncWpMarkers();
//       this._emitWaypoints();
//       this._rerouteAndUpdateFeature();
//     });

//     // Snaps — add other layers first, then _wpLayer LAST (highest priority)
//     this._snaps = [];
//     this.map.getLayers().forEach(layer => {
//       if (layer instanceof VectorLayer && layer !== this._wpLayer) {
//         const snap = new Snap({ source: layer.getSource() });
//         this._snaps.push(snap);
//         this.map.addInteraction(snap);
//       }
//     });

//   }

//   // ─────────────────────────────────────────────────────────
//   // DRAW MODE — guide_point management
//   // ─────────────────────────────────────────────────────────
//   _addGuidePoint(lonLat) {
//     this._guidePoints.push(lonLat);
//     this._syncWpMarkers();
//     this._emitWaypoints();
//     this._emitStatus();
//     if (this._guidePoints.length >= 2) this._reroute();
//   }

//   // ─────────────────────────────────────────────────────────
//   // SELECT MODE — load feature
//   // ─────────────────────────────────────────────────────────
//   _loadFeature(feature) {
//     // Ensure feature has an ID — server features have numeric ID,
//     // locally drawn features use ol_uid as fallback
//     if (!feature.getId()) feature.setId(feature.ol_uid);

//     let gps = feature.get("guide_points");
//     if (!Array.isArray(gps) || gps.length < 2) {
//       const geom   = feature.getGeometry();
//       const coords = geom?.getCoordinates() ?? [];
//       if (coords.length < 2) return;
//       gps = [coords[0], coords[coords.length - 1]];
//     }
//     this._activeFeature = feature;
//     this._guidePoints   = gps.map(ll => [...ll]);
//     // Do NOT clear undo/redo stacks here — previous adds/deletes must survive
//     this._syncWpMarkers();
//     this._emitWaypoints();
//     this._emitStatus();
//   }

//   // ─────────────────────────────────────────────────────────
//   // REROUTE
//   // ─────────────────────────────────────────────────────────
//   async _reroute() {
//     if (this._guidePoints.length < 2) return;
//     this.loading = true;
//     this._emitStatus();
//     try {
//       const coords = await osrmFetch(this.osrmUrl, this.profile, this._guidePoints);
//       if (!coords) { this.logger?.("OSRM: no route", "warning"); return; }
//       const olCoords = coords;
//       // Add mode: update temp preview line
//       this._setTempLine(olCoords);
//     } catch (err) {
//       this.logger?.(`OSRM error: ${err.message}`, "error");
//     } finally {
//       this.loading = false;
//       this._emitStatus();
//     }
//   }

//   async _rerouteAndUpdateFeature() {
//     if (this._guidePoints.length < 2) return;
//     this.loading = true;
//     this._emitStatus();
//     try {
//       const coords = await osrmFetch(this.osrmUrl, this.profile, this._guidePoints);
//       if (!coords) return;
//       const olCoords = coords;
//       if (this._activeFeature) {
//         this._activeFeature.getGeometry().setCoordinates(olCoords);
//         this._activeFeature.set("guide_points", this._guidePoints.map(ll => [...ll]));
//       } else {
//         this._setTempLine(olCoords);
//       }
//     } catch (err) {
//       this.logger?.(`OSRM error: ${err.message}`, "error");
//     } finally {
//       this.loading = false;
//       this._emitStatus();
//     }
//   }

//   // ─────────────────────────────────────────────────────────
//   // TEMP LINE
//   // ─────────────────────────────────────────────────────────
//   _setTempLine(olCoords) {
//     let f = this.routeSource.getFeatures().find(f => f.get("_temp_line"));
//     if (!f) {
//       f = new Feature({ geometry: new LineString(olCoords) });
//       f.set("_temp_line", true);
//       f.setStyle(TEMP_STYLE);
//       this.routeSource.addFeature(f);
//     } else {
//       f.getGeometry().setCoordinates(olCoords);
//     }
//   }

//   _clearTempLine() {
//     this.routeSource.getFeatures()
//       .filter(f => f.get("_temp_line"))
//       .forEach(f => this.routeSource.removeFeature(f));
//   }

//   // ─────────────────────────────────────────────────────────
//   // ADD FEATURE — commit temp line as real feature
//   // ─────────────────────────────────────────────────────────
//   addFeature(extraProps = {}) {
//     const temp = this.routeSource.getFeatures().find(f => f.get("_temp_line"));
//     if (!temp || this._guidePoints.length < 2) return null;

//     const feature = new Feature({
//       geometry: new LineString(temp.getGeometry().getCoordinates()),
//     });
//     const id = `route_${Date.now()}`;
//     feature.setId(id);
//     feature.set("guide_points",   this._guidePoints.map(ll => [...ll]));
//     feature.set("_route_feature", true);
//     Object.entries(extraProps).forEach(([k, v]) => feature.set(k, v));

//     this.routeSource.addFeature(feature);

//     // Push to undo stack so addFeature is undoable
//     this._pushUndo({
//       type:    "add",
//       id,
//       feature: feature.clone(),
//     });

//     // Clear draw state but DO NOT clear undoStack — commit needs the "add" entry
//     this._clearTempLine();
//     this._guidePoints   = [];
//     this._activeFeature = null;
//     this._wpSource.clear();
//     this._emitWaypoints();
//     this._emitStatus();
//     this.onFeatureAdded?.(feature);
//     return feature;
//   }

//   // ─────────────────────────────────────────────────────────
//   // DELETE selected route
//   // ─────────────────────────────────────────────────────────
//   deleteSelected() {
//     if (this.mode !== "select") return;
//     const selected = this._selectRoute.getFeatures().getArray();
//     if (!selected.length) return;

//     const deleted = selected.map(f => {
//       const clone = f.clone();
//       clone.setId(f.getId());
//       this.routeSource.removeFeature(f);
//       return clone;
//     });

//     this._pushUndo({ type: "delete", features: deleted });
//     this._selectRoute.getFeatures().clear();
//     this._clearMarkers();
//     this._emitStatus();
//   }

//   // ─────────────────────────────────────────────────────────
//   // WAYPOINT MUTATIONS (from UI list)
//   // ─────────────────────────────────────────────────────────
//   removeGuidePoint(idx) {
//     if (this._guidePoints.length <= 2) return;
//     this._pushUndo({ type: "drag", prev: this._guidePoints.map(ll => [...ll]), featureId: this._activeFeature?.getId() ?? null });
//     this._guidePoints.splice(idx, 1);
//     this._syncWpMarkers();
//     this._emitWaypoints();
//     this._rerouteAndUpdateFeature();
//   }

//   setGuidePointType(idx, type) {
//     const f = this._wpSource.getFeatureById(`wp_${idx}`);
//     if (f) f.set("wp_type", type);
//     this._emitWaypoints();
//   }

//   // ─────────────────────────────────────────────────────────
//   // MARKERS
//   // ─────────────────────────────────────────────────────────
//   _syncWpMarkers() {
//     this._wpSource.clear();
//     const n = this._guidePoints.length;
//     this._guidePoints.forEach((ll, i) => {
//       const coord = this.mode === "draw" ? ll : ll;
//       const f = new Feature({ geometry: new Point(coord) });
//       f.setId(`wp_${i}`);
//       f.set("wp_index", i);
//       f.set("wp_type",
//         i === 0       ? WP_TYPES.START
//         : i === n - 1 ? WP_TYPES.STOP
//         : WP_TYPES.THROUGH
//       );
//       this._wpSource.addFeature(f);
//     });
//   }

//   _clearMarkers() {
//     this._guidePoints   = [];
//     this._activeFeature = null;
//     this._wpSource.clear();
//     this._emitWaypoints();
//   }

//   _clearAllState() {
//     this._guidePoints   = [];
//     this._activeFeature = null;
//     this._undoStack     = [];
//     this._redoStack     = [];
//     this._wpSource.clear();
//     this._emitWaypoints();
//     this._emitStatus();
//   }

//   // ─────────────────────────────────────────────────────────
//   // UNDO / REDO
//   // ─────────────────────────────────────────────────────────
//   _pushUndo(action) {
//     this._undoStack.push(action);
//     if (this._undoStack.length > 50) this._undoStack.shift();
//     this._redoStack = [];
//     this._emitStatus();
//   }

//   undo() {
//     if (!this._undoStack.length) return;
//     const action = this._undoStack.pop();

//     if (action.type === "add") {
//       // Undo addFeature — remove the added feature
//       const f = this.routeSource.getFeatureById(action.id);
//       if (f) this.routeSource.removeFeature(f);
//       this._redoStack.push(action);
//     } else if (action.type === "delete") {
//       // Undo delete — re-add features
//       action.features.forEach(f => this.routeSource.addFeature(f));
//       this._redoStack.push(action);
//     } else if (action.type === "drag") {
//       // Undo drag — restore guide_points snapshot and reroute
//       const current = this._guidePoints.map(ll => [...ll]);
//       this._redoStack.push({ type: "drag", prev: current, featureId: action.featureId });
//       this._guidePoints = action.prev.map(ll => [...ll]);
//       this._syncWpMarkers();
//       this._emitWaypoints();
//       this._rerouteAndUpdateFeature();
//     }

//     this._emitStatus();
//   }

//   redo() {
//     if (!this._redoStack.length) return;
//     const action = this._redoStack.pop();

//     if (action.type === "add") {
//       this.routeSource.addFeature(action.feature);
//       this._undoStack.push(action);
//     } else if (action.type === "delete") {
//       action.features.forEach(f => this.routeSource.removeFeature(
//         this.routeSource.getFeatureById(f.getId())
//       ));
//       this._undoStack.push(action);
//     } else if (action.type === "drag") {
//       const current = this._guidePoints.map(ll => [...ll]);
//       this._undoStack.push({ type: "drag", prev: current, featureId: action.featureId });
//       this._guidePoints = action.prev.map(ll => [...ll]);
//       this._syncWpMarkers();
//       this._emitWaypoints();
//       this._rerouteAndUpdateFeature();
//     }

//     this._emitStatus();
//   }

//   // ─────────────────────────────────────────────────────────
//   // COMMIT
//   // ─────────────────────────────────────────────────────────
//   commit() {
//     const layerId      = this.routeLayer.get("layer_id");
//     const geometryType = (this.routeLayer.get("geometry_type") ?? "LINESTndowRING").toUpperCase();
//     const wkt          = new WKB();

//     // Walk undo stack — last write per feature ID wins (Map deduplicates)
//     const commits = new Map();
//     const created = new Set();

//     for (const action of this._undoStack) {
//       if (action.type === "add") {
//         created.add(action.id);
//         commits.set(action.id, { type: "NEW", state: "add" });

//       } else if (action.type === "delete") {
//         action.features.forEach(f => {
//           const id = f.getId();
//           if (created.has(id)) {
//             // Created and deleted this session — net zero
//             commits.delete(id);
//             created.delete(id);
//           } else {
//             commits.set(id, { type: "OLD", state: "delete" });
//           }
//         });

//       } else if (action.type === "drag") {
//         const id = action.featureId;
//         if (!id) continue;
//         if (created.has(id)) {
//           // Dragged after being added — still "add" with updated geometry
//           commits.set(id, { type: "NEW", state: "add" });
//         } else {
//           // Pre-existing feature — update (overwrite any previous drag entry)
//           commits.set(id, { type: "OLD", state: "update" });
//         }
//       }
//     }

//     // Build API payload — commits is a Map so each id appears exactly once.
//     // Additional dedup maps guard against any edge cases.
//     const seen = { create: new Set(), update: new Set(), delete: new Set() };
//     const payload = { create: [], update: [], delete: [] };

//     for (const [id, entry] of commits.entries()) {
//       const feature    = this.routeSource.getFeatureById(id);
//       const geomWkt    = feature?.getGeometry()
//         ? wkt.writeGeometry(feature.getGeometry())
//         : null;
//       const properties = feature
//         ? Object.fromEntries(
//             Object.entries(feature.getProperties())
//               .filter(([k]) => k !== "geometry")
//           )
//         : {};

//       if (entry.state === "add") {
//         if (seen.create.has(id)) continue;
//         seen.create.add(id);
//         payload.create.push({
//           layer_id: layerId, 
//           geometry_type: geometryType,
//           geometry: geomWkt, properties,
//         });
//       } else if (entry.state === "update") {
//         if (seen.update.has(id)) continue;
//         seen.update.add(id);
//         payload.update.push({
//           layer_id: layerId, id,
//           geometry_type: geometryType, geometry: geomWkt, properties,
//         });
//       } else if (entry.state === "delete") {
//         if (seen.delete.has(id)) continue;
//         seen.delete.add(id);
//         payload.delete.push({
//           layer_id: layerId, id, geometry_type: geometryType,
//         });
//       }
//     }

//     this.onCommit?.({ commits, payload });
//   }

//   confirmCommit() {
//     this._undoStack = [];
//     this._redoStack = [];
//     this._emitStatus();
//     this.routeSource.refresh();
//   }

//   rollbackAll() {
//     this._undoStack = [];
//     this._redoStack = [];
//     this._emitStatus();
//     this.routeSource.refresh();
//   }

//   // ─────────────────────────────────────────────────────────
//   // MODE / EDIT CONTROL  (same API as GeometryEditorCore)
//   // ─────────────────────────────────────────────────────────
//   startEdit() {
//     this.editing = true;
//     this.enableDrawMode();
//   }

//   stopEdit() {
//     this.editing = false;
//     this.mode    = "none";
//     this._removeBackspace();
//     this._draw.setActive(false);
//     this._modifyMarkers.setActive(false);
//     this._modifyLine.setActive(false);
//     this._selectRoute.getFeatures().clear();
//     this._clearAllState();
//     this._clearTempLine();
//     this._emitStatus();
//   }

//   enableDrawMode() {
//     if (!this.editing) return;
//     this.mode = "draw";
//     this._selectRoute.getFeatures().clear();
//     this._clearMarkers();
//     this._clearTempLine();
//     this._draw.setActive(true);
//     this._modifyMarkers.setActive(false);
//     this._modifyLine.setActive(false);

//     // Attach backspace — removes last waypoint while drawing
//     this._removeBackspace();
//     this._onBackspace = (ev) => {
//       if (ev.key !== "Backspace" && ev.keyCode !== 8) return;
//       ev.preventDefault();
//       if (this._guidePoints.length === 0) return;
//       this._guidePoints.pop();
//       this._syncWpMarkers();
//       this._emitWaypoints();
//       if (this._guidePoints.length >= 2) this._reroute();
//       else this._clearTempLine();
//       this._emitStatus(); // update canAddFeature in UI
//     };
//     window.addEventListener("keydown", this._onBackspace);

//     this._emitStatus();
//   }

//   _removeBackspace() {
//     if (this._onBackspace) {
//       window.removeEventListener("keydown", this._onBackspace);
//       this._onBackspace = null;
//     }
//   }

//   enableSelectMode() {
//     if (!this.editing) return;
//     this.mode = "select";
//     this._removeBackspace();
//     this._draw.setActive(false);
//     this._modifyMarkers.setActive(true);
//     this._modifyLine.setActive(true);
//     this._emitStatus();
//   }

//   // ─────────────────────────────────────────────────────────
//   // STATUS
//   // ─────────────────────────────────────────────────────────
//   canAddFeature() {
//     return (
//       this.mode === "draw" &&
//       this._guidePoints.length >= 2 &&
//       !!this.routeSource.getFeatures().find(f => f.get("_temp_line"))
//     );
//   }

//   getWaypoints() {
//     const n = this._guidePoints.length;
//     return this._guidePoints.map((ll, i) => {
//       const f    = this._wpSource.getFeatureById(`wp_${i}`);
//       const type = f?.get("wp_type")
//         ?? (i === 0 ? WP_TYPES.START : i === n-1 ? WP_TYPES.STOP : WP_TYPES.THROUGH);
//       return { id: `wp_${i}`, lonLat: ll, index: i, type };
//     });
//   }

//   status() {
//     return {
//       editing:          this.editing,
//       loading:          this.loading,
//       mode:             this.mode,
//       undo:             this._undoStack.length,
//       redo:             this._redoStack.length,
//       waypoints:        this._guidePoints.length,
//       canAddFeature:    this.canAddFeature(),
//       editingFeatureId: this._activeFeature?.getId() ?? null,
//     };
//   }

//   _emitStatus()    { this.onStatusChange?.(this.status()); }
//   _emitWaypoints() { this.onWaypointsChange?.(this.getWaypoints()); }

//   destroy() {
//     this._removeBackspace();
//     this.map.removeLayer(this._wpLayer);
//     this.map.removeInteraction(this._selectRoute);
//     this.map.removeInteraction(this._draw);
//     this.map.removeInteraction(this._modifyMarkers);
//     this.map.removeInteraction(this._modifyLine);
//     this._snaps.forEach(s => this.map.removeInteraction(s));
//     if (this._wpSnap) this.map.removeInteraction(this._wpSnap);
//     this._snaps = [];
//     this._clearTempLine();
//   }
// }


import VectorLayer  from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Feature      from "ol/Feature";
import Point        from "ol/geom/Point";
import LineString   from "ol/geom/LineString";
import Select       from "ol/interaction/Select";
import Modify       from "ol/interaction/Modify";
import Snap         from "ol/interaction/Snap";
import Draw         from "ol/interaction/Draw";
import Style        from "ol/style/Style";
import Stroke       from "ol/style/Stroke";
import Fill         from "ol/style/Fill";
import CircleStyle  from "ol/style/Circle";
import Text         from "ol/style/Text";
import WKB from "ol/format/WKB";
import { click }    from "ol/events/condition";

export const WP_TYPES = Object.freeze({
  START: "start", STOP: "stop", THROUGH: "through", BREAK: "break", VIA: "via",
});

export const TYPE_COLORS = {
  [WP_TYPES.START]:   "#2e7d32",
  [WP_TYPES.STOP]:    "#c62828",
  [WP_TYPES.THROUGH]: "#1565c0",
  [WP_TYPES.BREAK]:   "#f57f17",
  [WP_TYPES.VIA]:     "#6a1b9a",
};

// ── Styles ──────────────────────────────────────────────
const wpStyle = (f) => {
  const type  = f.get("wp_type")  ?? WP_TYPES.THROUGH;
  const index = f.get("wp_index") ?? 0;
  const color = TYPE_COLORS[type] ?? "#333";
  return [
    new Style({
      image: new CircleStyle({
        radius: 8,
        fill:   new Fill({ color }),
        stroke: new Stroke({ color: "#fff", width: 2 }),
      }),
    }),
    new Style({
      text: new Text({
        text: String(index + 1),
        font: "bold 10px sans-serif",
        fill: new Fill({ color: "#fff" }),
        offsetY: 0.5,
      }),
    }),
  ];
};

const TEMP_STYLE = new Style({
  stroke: new Stroke({ color: "#1565c0", width: 3, lineDash: [8, 4] }),
});

const ROUTE_STYLE = new Style({
  stroke: new Stroke({ color: "#1565c0", width: 4 }),
});

// ── OSRM ────────────────────────────────────────────────
async function osrmFetch(url, profile, waypoints) {
  const coords = waypoints.map(w => `${w[0]},${w[1]}`).join(";");
  const res    = await fetch(
    `${url}/route/v1/${profile}/${coords}?overview=full&geometries=geojson`
  );
  const data   = await res.json();
  if (data.code !== "Ok" || !data.routes?.length) return null;
  return data.routes[0].geometry.coordinates;
}

// ── Distance helpers ─────────────────────────────────────
function cumulativeDist(coords) {
  const dist = [0];
  for (let i = 1; i < coords.length; i++) {
    const dx = coords[i][0] - coords[i-1][0];
    const dy = coords[i][1] - coords[i-1][1];
    dist.push(dist[i-1] + Math.sqrt(dx*dx + dy*dy));
  }
  return dist;
}

function findInsertIndex(dragCoord, lineCoords, guidePoints) {
  if (!lineCoords.length || !guidePoints.length) return 1;
  const cumDist = cumulativeDist(lineCoords);
  let minDist = Infinity, dragDist = 0;
  lineCoords.forEach((c, i) => {
    const d = (c[0]-dragCoord[0])**2 + (c[1]-dragCoord[1])**2;
    if (d < minDist) { minDist = d; dragDist = cumDist[i]; }
  });
  const gpDists = guidePoints.map(gp => {
    let minD = Infinity, gpDist = 0;
    lineCoords.forEach((c, i) => {
      const d = (c[0]-gp[0])**2 + (c[1]-gp[1])**2;
      if (d < minD) { minD = d; gpDist = cumDist[i]; }
    });
    return gpDist;
  });
  let idx = 1;
  for (let i = 0; i < gpDists.length - 1; i++) {
    if (gpDists[i] <= dragDist) idx = i + 1;
  }
  return idx;
}

// ─────────────────────────────────────────────────────────
// ROUTE EDITOR CORE
//
// mode: "none" | "draw" | "select"   ← matches GeometryEditor pattern
//
// DRAW mode:
//   Click to add waypoints → OSRM between each pair → temp preview line
//   Backspace removes last waypoint (no undo stack during active draw)
//   addFeature() commits preview as real feature + pushes to undoStack
//
// SELECT mode:
//   Click existing route → loads guide_points as draggable markers
//   Drag marker (modifyMarkers) → update guide_point → reroute
//   Drag line vertex (modifyLine) → insert new guide_point → reroute
//   Both drag operations push to undoStack
//
// UNDO/REDO:
//   Covers: addFeature, deleteSelected, drag-modify
//   Does NOT cover: active draw (use backspace instead)
// ─────────────────────────────────────────────────────────
export default class RouteEditorCore {
  constructor(map, routeLayer, logger, opts = {}) {
    this.map         = map;
    this.routeLayer  = routeLayer;
    this.routeSource = routeLayer.getSource();
    this.logger      = logger;
    this.osrmUrl     = opts.osrmUrl ?? "https://router.project-osrm.org";
    this.profile     = opts.profile ?? "driving";

    this.onStatusChange    = opts.onStatusChange    ?? null;
    this.onWaypointsChange = opts.onWaypointsChange ?? null;
    this.onFeatureAdded    = opts.onFeatureAdded    ?? null;
    this.onCommit          = opts.onCommit          ?? null;

    this.editing         = false;
    this.loading         = false;
    this.mode            = "none";   // "none" | "draw" | "select"

    // Active draw waypoints — backspace pops from here, NOT from undoStack
    this._guidePoints    = [];
    this._activeFeature  = null;

    // Undo/Redo — only for committed operations (addFeature, delete, drag)
    this._undoStack      = [];
    this._redoStack      = [];

    // Backspace handler ref (removed on drawend / stopEdit)
    this._onBackspace    = null;

    // Overlay layer for waypoint markers
    this._wpSource = new VectorSource();
    this._wpLayer  = new VectorLayer({
      source: this._wpSource,
      zIndex: 200,
      style:  wpStyle,
    });
    map.addLayer(this._wpLayer);

    this._buildInteractions();

    // Waypoint snap — created after interactions, added last = highest priority
    this._wpSnap = new Snap({ source: this._wpSource, pixelTolerance: 15 });
    this.map.addInteraction(this._wpSnap);
  }

  // ─────────────────────────────────────────────────────────
  // INTERACTIONS
  // ─────────────────────────────────────────────────────────
  _buildInteractions() {
    // Select existing route features (select mode)
    this._selectRoute = new Select({
      layers:    [this.routeLayer],
      condition: click,
      filter:    f => !f.get("_temp_line"),
      style:     null,
    });
    this.map.addInteraction(this._selectRoute);

    this._selectRoute.on("select", e => {
      if (!this.editing || this.mode !== "select") return;
      const f = e.selected[0];
      if (f) this._loadFeature(f);
      else   this._clearMarkers();
    });

    // Draw — click to add waypoints (draw mode)
    this._draw = new Draw({ source: this._wpSource, type: "Point" });
    this._draw.setActive(false);
    this.map.addInteraction(this._draw);

    // Backspace handler — attached when draw mode starts, removed on mode switch
    this._onBackspace = null;

    this._draw.on("drawend", e => {
      // Remove auto-added point from wpSource — we manage manually
      setTimeout(() => this._wpSource.removeFeature(e.feature), 0);
      const lonLat = e.feature.getGeometry().getCoordinates();
      this._addGuidePoint(lonLat);
    });

    // Modify markers — drag guide_point markers
    this._modifyMarkers = new Modify({ source: this._wpSource });
    this._modifyMarkers.setActive(false);
    this.map.addInteraction(this._modifyMarkers);

    this._preDragGuidePoints = null;
    this._modifyMarkers.on("modifystart", () => {
      this._preDragGuidePoints = this._guidePoints.map(ll => [...ll]);
    });
    this._modifyMarkers.on("modifyend", e => {
      const f = e.features.getArray()[0];
      if (!f) return;
      const wpIdx  = f.get("wp_index");
      const lonLat = f.getGeometry().getCoordinates();
      if (wpIdx === undefined) return;
      // Push undo BEFORE applying
      this._pushUndo({ type: "drag", prev: this._preDragGuidePoints, featureId: this._activeFeature?.getId() ?? null });
      this._guidePoints[wpIdx] = lonLat;
      this._syncWpMarkers();
      this._emitWaypoints();
      this._rerouteAndUpdateFeature();
    });

    // Modify line — drag directly on route line vertex
    this._modifyLine = new Modify({ features: this._selectRoute.getFeatures() });
    this._modifyLine.setActive(false);
    this.map.addInteraction(this._modifyLine);

    this._preDragLineCoords = null;
    this._modifyLine.on("modifystart", e => {
      this._preDragGuidePoints = this._guidePoints.map(ll => [...ll]);
      const f = e.features.getArray()[0];
      this._preDragLineCoords = f
        ? f.getGeometry().getCoordinates().map(c => [...c])
        : null;
    });
    this._modifyLine.on("modifyend", e => {
      if (!this._activeFeature) return;
      const f           = e.features.getArray()[0];
      const afterCoords = f?.getGeometry().getCoordinates() ?? [];
      const beforeCoords= this._preDragLineCoords ?? [];

      // Find vertex that moved most
      let dragCoord = null, maxDist = 0;
      afterCoords.forEach(ac => {
        const nearestDist = beforeCoords.reduce((best, bc) => {
          const d = (ac[0]-bc[0])**2 + (ac[1]-bc[1])**2;
          return Math.min(best, d);
        }, Infinity);
        if (nearestDist > maxDist) { maxDist = nearestDist; dragCoord = ac; }
      });

      if (!dragCoord || maxDist < 1e-10) return;

      this._pushUndo({ type: "drag", prev: this._preDragGuidePoints, featureId: this._activeFeature?.getId() ?? null });
      const insertIdx = findInsertIndex(dragCoord, afterCoords, this._guidePoints);
      this._guidePoints.splice(insertIdx, 0, dragCoord);
      this._syncWpMarkers();
      this._emitWaypoints();
      this._rerouteAndUpdateFeature();
    });

    // Snaps — add other layers first, then _wpLayer LAST (highest priority)
    this._snaps = [];
    this.map.getLayers().forEach(layer => {
      if (layer instanceof VectorLayer && layer !== this._wpLayer) {
        const snap = new Snap({ source: layer.getSource() });
        this._snaps.push(snap);
        this.map.addInteraction(snap);
      }
    });

  }

  // ─────────────────────────────────────────────────────────
  // DRAW MODE — guide_point management
  // ─────────────────────────────────────────────────────────
  _addGuidePoint(lonLat) {
    this._guidePoints.push(lonLat);
    this._syncWpMarkers();
    this._emitWaypoints();
    this._emitStatus();
    if (this._guidePoints.length >= 2) this._reroute();
  }

  // ─────────────────────────────────────────────────────────
  // SELECT MODE — load feature
  // ─────────────────────────────────────────────────────────
  _loadFeature(feature) {
    // Ensure feature has an ID — server features have numeric ID,
    // locally drawn features use ol_uid as fallback
    if (!feature.getId()) feature.setId(feature.ol_uid);

    let gps = feature.get("guide_points");
    if (!Array.isArray(gps) || gps.length < 2) {
      const geom   = feature.getGeometry();
      const coords = geom?.getCoordinates() ?? [];
      if (coords.length < 2) return;
      gps = [coords[0], coords[coords.length - 1]];
    }
    this._activeFeature = feature;
    this._guidePoints   = gps.map(ll => [...ll]);
    // Do NOT clear undo/redo stacks here — previous adds/deletes must survive
    this._syncWpMarkers();
    this._emitWaypoints();
    this._emitStatus();
  }

  // ─────────────────────────────────────────────────────────
  // REROUTE
  // ─────────────────────────────────────────────────────────
  async _reroute() {
    if (this._guidePoints.length < 2) return;
    this.loading = true;
    this._emitStatus();
    try {
      const coords = await osrmFetch(this.osrmUrl, this.profile, this._guidePoints);
      if (!coords) { this.logger?.("OSRM: no route", "warning"); return; }
      const olCoords = coords;
      // Add mode: update temp preview line
      this._setTempLine(olCoords);
    } catch (err) {
      this.logger?.(`OSRM error: ${err.message}`, "error");
    } finally {
      this.loading = false;
      this._emitStatus();
    }
  }

  async _rerouteAndUpdateFeature() {
    if (this._guidePoints.length < 2) return;
    this.loading = true;
    this._emitStatus();
    try {
      const coords = await osrmFetch(this.osrmUrl, this.profile, this._guidePoints);
      if (!coords) return;
      const olCoords = coords;
      if (this._activeFeature) {
        this._activeFeature.getGeometry().setCoordinates(olCoords);
        this._activeFeature.set("guide_points", this._guidePoints.map(ll => [...ll]));
      } else {
        this._setTempLine(olCoords);
      }
    } catch (err) {
      this.logger?.(`OSRM error: ${err.message}`, "error");
    } finally {
      this.loading = false;
      this._emitStatus();
    }
  }

  // ─────────────────────────────────────────────────────────
  // TEMP LINE
  // ─────────────────────────────────────────────────────────
  _setTempLine(olCoords) {
    let f = this.routeSource.getFeatures().find(f => f.get("_temp_line"));
    if (!f) {
      f = new Feature({ geometry: new LineString(olCoords) });
      f.set("_temp_line", true);
      f.setStyle(TEMP_STYLE);
      this.routeSource.addFeature(f);
    } else {
      f.getGeometry().setCoordinates(olCoords);
    }
  }

  _clearTempLine() {
    this.routeSource.getFeatures()
      .filter(f => f.get("_temp_line"))
      .forEach(f => this.routeSource.removeFeature(f));
  }

  // ─────────────────────────────────────────────────────────
  // ADD FEATURE — commit temp line as real feature
  // ─────────────────────────────────────────────────────────
  addFeature(extraProps = {}) {
    const temp = this.routeSource.getFeatures().find(f => f.get("_temp_line"));
    if (!temp || this._guidePoints.length < 2) return null;

    const feature = new Feature({
      geometry: new LineString(temp.getGeometry().getCoordinates()),
    });
    const id = `route_${Date.now()}`;
    feature.setId(id);
    feature.set("guide_points",   this._guidePoints.map(ll => [...ll]));
    feature.set("_route_feature", true);
    Object.entries(extraProps).forEach(([k, v]) => feature.set(k, v));

    this.routeSource.addFeature(feature);

    // Push to undo stack so addFeature is undoable
    this._pushUndo({
      type:    "add",
      id,
      feature: feature.clone(),
    });

    // Clear draw state but DO NOT clear undoStack — commit needs the "add" entry
    this._clearTempLine();
    this._guidePoints   = [];
    this._activeFeature = null;
    this._wpSource.clear();
    this._emitWaypoints();
    this._emitStatus();
    this.onFeatureAdded?.(feature);
    return feature;
  }

  // ─────────────────────────────────────────────────────────
  // DELETE selected route
  // ─────────────────────────────────────────────────────────
  deleteSelected() {
    if (this.mode !== "select") return;
    const selected = this._selectRoute.getFeatures().getArray();
    if (!selected.length) return;

    const deleted = selected.map(f => {
      const clone = f.clone();
      clone.setId(f.getId());
      this.routeSource.removeFeature(f);
      return clone;
    });

    this._pushUndo({ type: "delete", features: deleted });
    this._selectRoute.getFeatures().clear();
    this._clearMarkers();
    this._emitStatus();
  }

  // ─────────────────────────────────────────────────────────
  // WAYPOINT MUTATIONS (from UI list)
  // ─────────────────────────────────────────────────────────
  removeGuidePoint(idx) {
    if (this._guidePoints.length <= 2) return;
    this._pushUndo({ type: "drag", prev: this._guidePoints.map(ll => [...ll]), featureId: this._activeFeature?.getId() ?? null });
    this._guidePoints.splice(idx, 1);
    this._syncWpMarkers();
    this._emitWaypoints();
    this._rerouteAndUpdateFeature();
  }

  setGuidePointType(idx, type) {
    const f = this._wpSource.getFeatureById(`wp_${idx}`);
    if (f) f.set("wp_type", type);
    this._emitWaypoints();
  }

  // ─────────────────────────────────────────────────────────
  // MARKERS
  // ─────────────────────────────────────────────────────────
  _syncWpMarkers() {
    this._wpSource.clear();
    const n = this._guidePoints.length;
    this._guidePoints.forEach((ll, i) => {
      const coord = this.mode === "draw" ? ll : ll;
      const f = new Feature({ geometry: new Point(coord) });
      f.setId(`wp_${i}`);
      f.set("wp_index", i);
      f.set("wp_type",
        i === 0       ? WP_TYPES.START
        : i === n - 1 ? WP_TYPES.STOP
        : WP_TYPES.THROUGH
      );
      this._wpSource.addFeature(f);
    });
  }

  _clearMarkers() {
    this._guidePoints   = [];
    this._activeFeature = null;
    this._wpSource.clear();
    this._emitWaypoints();
  }

  _clearAllState() {
    this._guidePoints   = [];
    this._activeFeature = null;
    this._undoStack     = [];
    this._redoStack     = [];
    this._wpSource.clear();
    this._emitWaypoints();
    this._emitStatus();
  }

  // ─────────────────────────────────────────────────────────
  // UNDO / REDO
  // ─────────────────────────────────────────────────────────
  _pushUndo(action) {
    this._undoStack.push(action);
    if (this._undoStack.length > 50) this._undoStack.shift();
    this._redoStack = [];
    this._emitStatus();
  }

  undo() {
    if (!this._undoStack.length) return;
    const action = this._undoStack.pop();

    if (action.type === "add") {
      // Undo addFeature — remove the added feature
      const f = this.routeSource.getFeatureById(action.id);
      if (f) this.routeSource.removeFeature(f);
      this._redoStack.push(action);
    } else if (action.type === "delete") {
      // Undo delete — re-add features
      action.features.forEach(f => this.routeSource.addFeature(f));
      this._redoStack.push(action);
    } else if (action.type === "drag") {
      // Undo drag — restore guide_points snapshot and reroute
      const current = this._guidePoints.map(ll => [...ll]);
      this._redoStack.push({ type: "drag", prev: current, featureId: action.featureId });
      this._guidePoints = action.prev.map(ll => [...ll]);
      this._syncWpMarkers();
      this._emitWaypoints();
      this._rerouteAndUpdateFeature();
    }

    this._emitStatus();
  }

  redo() {
    if (!this._redoStack.length) return;
    const action = this._redoStack.pop();

    if (action.type === "add") {
      this.routeSource.addFeature(action.feature);
      this._undoStack.push(action);
    } else if (action.type === "delete") {
      action.features.forEach(f => this.routeSource.removeFeature(
        this.routeSource.getFeatureById(f.getId())
      ));
      this._undoStack.push(action);
    } else if (action.type === "drag") {
      const current = this._guidePoints.map(ll => [...ll]);
      this._undoStack.push({ type: "drag", prev: current, featureId: action.featureId });
      this._guidePoints = action.prev.map(ll => [...ll]);
      this._syncWpMarkers();
      this._emitWaypoints();
      this._rerouteAndUpdateFeature();
    }

    this._emitStatus();
  }

  // ─────────────────────────────────────────────────────────
  // COMMIT
  // ─────────────────────────────────────────────────────────
  commit() {
    const layerId      = this.routeLayer.get("layer_id");
    const geometryType = (this.routeLayer.get("geometry_type") ?? "LINESTndowRING").toUpperCase();
    const wkt          = new WKB();

    // Walk undo stack — last write per feature ID wins (Map deduplicates)
    const commits = new Map();
    const created = new Set();

    for (const action of this._undoStack) {
      if (action.type === "add") {
        created.add(action.id);
        commits.set(action.id, { type: "NEW", state: "add" });

      } else if (action.type === "delete") {
        action.features.forEach(f => {
          const id = f.getId();
          if (created.has(id)) {
            // Created and deleted this session — net zero
            commits.delete(id);
            created.delete(id);
          } else {
            commits.set(id, { type: "OLD", state: "delete" });
          }
        });

      } else if (action.type === "drag") {
        const id = action.featureId;
        if (!id) continue;
        if (created.has(id)) {
          // Dragged after being added — still "add" with updated geometry
          commits.set(id, { type: "NEW", state: "add" });
        } else {
          // Pre-existing feature — update (overwrite any previous drag entry)
          commits.set(id, { type: "OLD", state: "update" });
        }
      }
    }

    // Build API payload — commits is a Map so each id appears exactly once.
    // Additional dedup maps guard against any edge cases.
    const seen = { create: new Set(), update: new Set(), delete: new Set() };
    const payload = { create: [], update: [], delete: [] };

    for (const [id, entry] of commits.entries()) {
      const feature    = this.routeSource.getFeatureById(id);
      const geomWkt    = feature?.getGeometry()
        ? wkt.writeGeometry(feature.getGeometry())
        : null;
      const properties = feature
        ? Object.fromEntries(
            Object.entries(feature.getProperties())
              .filter(([k]) => k !== "geometry")
          )
        : {};

      if (entry.state === "add") {
        if (seen.create.has(id)) continue;
        seen.create.add(id);
        payload.create.push({
          layer_id: layerId, 
          geometry_type: geometryType,
          geometry: geomWkt, properties,
        });
      } else if (entry.state === "update") {
        if (seen.update.has(id)) continue;
        seen.update.add(id);
        payload.update.push({
          layer_id: layerId, id,
          geometry_type: geometryType, geometry: geomWkt, properties,
        });
      } else if (entry.state === "delete") {
        if (seen.delete.has(id)) continue;
        seen.delete.add(id);
        payload.delete.push({
          layer_id: layerId, id, geometry_type: geometryType,
        });
      }
    }

    this.onCommit?.({ commits, payload });
  }

  confirmCommit() {
    this._undoStack = [];
    this._redoStack = [];
    this._emitStatus();
    this.routeSource.refresh();
  }

  rollbackAll() {
    this._undoStack = [];
    this._redoStack = [];
    this._emitStatus();
    this.routeSource.refresh();
  }

  // ─────────────────────────────────────────────────────────
  // MODE / EDIT CONTROL  (same API as GeometryEditorCore)
  // ─────────────────────────────────────────────────────────
  startEdit() {
    this.editing = true;
    this.enableDrawMode();
  }

  stopEdit() {
    this.editing = false;
    this.mode    = "none";
    this._removeBackspace();
    this._draw.setActive(false);
    this._modifyMarkers.setActive(false);
    this._modifyLine.setActive(false);
    this._selectRoute.getFeatures().clear();
    this._clearAllState();
    this._clearTempLine();
    this._emitStatus();
  }

  enableDrawMode() {
    if (!this.editing) return;
    this.mode = "draw";
    this._selectRoute.getFeatures().clear();
    this._clearMarkers();
    this._clearTempLine();
    this._draw.setActive(true);
    this._modifyMarkers.setActive(false);
    this._modifyLine.setActive(false);

    // Attach backspace — removes last waypoint while drawing
    this._removeBackspace();
    this._onBackspace = (ev) => {
      if (ev.key !== "Backspace" && ev.keyCode !== 8) return;
      ev.preventDefault();
      if (this._guidePoints.length === 0) return;
      this._guidePoints.pop();
      this._syncWpMarkers();
      this._emitWaypoints();
      if (this._guidePoints.length >= 2) this._reroute();
      else this._clearTempLine();
      this._emitStatus(); // update canAddFeature in UI
    };
    // Attach to map viewport — only fires when map has focus, not inputs/dialogs
    const viewport = this.map.getViewport();
    viewport.setAttribute("tabindex", "0"); // make viewport focusable
    viewport.focus();
    viewport.addEventListener("keydown", this._onBackspace);

    this._emitStatus();
  }

  _removeBackspace() {
    if (this._onBackspace) {
      this.map.getViewport().removeEventListener("keydown", this._onBackspace);
      this._onBackspace = null;
    }
  }

  enableSelectMode() {
    if (!this.editing) return;
    this.mode = "select";
    this._removeBackspace();
    this._draw.setActive(false);
    this._modifyMarkers.setActive(true);
    this._modifyLine.setActive(true);
    this._emitStatus();
  }

  // ─────────────────────────────────────────────────────────
  // STATUS
  // ─────────────────────────────────────────────────────────
  canAddFeature() {
    return (
      this.mode === "draw" &&
      this._guidePoints.length >= 2 &&
      !!this.routeSource.getFeatures().find(f => f.get("_temp_line"))
    );
  }

  getWaypoints() {
    const n = this._guidePoints.length;
    return this._guidePoints.map((ll, i) => {
      const f    = this._wpSource.getFeatureById(`wp_${i}`);
      const type = f?.get("wp_type")
        ?? (i === 0 ? WP_TYPES.START : i === n-1 ? WP_TYPES.STOP : WP_TYPES.THROUGH);
      return { id: `wp_${i}`, lonLat: ll, index: i, type };
    });
  }

  status() {
    return {
      editing:          this.editing,
      loading:          this.loading,
      mode:             this.mode,
      undo:             this._undoStack.length,
      redo:             this._redoStack.length,
      waypoints:        this._guidePoints.length,
      canAddFeature:    this.canAddFeature(),
      editingFeatureId: this._activeFeature?.getId() ?? null,
    };
  }

  _emitStatus()    { this.onStatusChange?.(this.status()); }
  _emitWaypoints() { this.onWaypointsChange?.(this.getWaypoints()); }

  destroy() {
    this._removeBackspace();
    this.map.removeLayer(this._wpLayer);
    this.map.removeInteraction(this._selectRoute);
    this.map.removeInteraction(this._draw);
    this.map.removeInteraction(this._modifyMarkers);
    this.map.removeInteraction(this._modifyLine);
    this._snaps.forEach(s => this.map.removeInteraction(s));
    if (this._wpSnap) this.map.removeInteraction(this._wpSnap);
    this._snaps = [];
    this._clearTempLine();
  }
}